// extracted by css-extract-rspack-plugin
var _1 = "src-components-Settings-SectionHeader-module__sectionHeader-TMx2N4";
var _2 = "src-components-Settings-SectionHeader-module__sectionHeaderIcon-xZ0pLi";
var _3 = "src-components-Settings-SectionHeader-module__sectionHeaderTitle-Jabbrj";
var _4 = "src-components-Settings-SectionHeader-module__settingsSectionIconBg-krN4AK";
export { _1 as "sectionHeader", _2 as "sectionHeaderIcon", _3 as "sectionHeaderTitle", _4 as "settingsSectionIconBg" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"sectionHeader\":\"src-components-Settings-SectionHeader-module__sectionHeader-TMx2N4\",\"sectionHeaderIcon\":\"src-components-Settings-SectionHeader-module__sectionHeaderIcon-xZ0pLi\",\"sectionHeaderTitle\":\"src-components-Settings-SectionHeader-module__sectionHeaderTitle-Jabbrj\",\"settingsSectionIconBg\":\"src-components-Settings-SectionHeader-module__settingsSectionIconBg-krN4AK\"}";
        // 1752373455079
        var cssReload = require("../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  